<template>
  <div>
    <el-row>
      <el-col :span="8">
        <div class="block">
          <span class="demonstration">门店选择：</span>
          <el-select
            v-model="selectedShop"
            multiple
            filterable
            value-key="shopid"
            :multiple-limit="3"
            placeholder="请选择且最多选择三个门店"
            style="width:66.6666666666%;"
          >
            <el-option
              v-for="item in shopList"
              :key="item.shopid"
              :label="item.shopName"
              :value="item.shopid"
            ></el-option>
          </el-select>
        </div>
      </el-col>
    </el-row>
    <el-row class="m-mt20">
      <el-col :span="18">
        <div class="block">
          <span class="demonstration">时间范围：</span>
          <!-- <el-time-picker
            is-range
            v-model="hourRange"
            range-separator="~"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            placeholder="选择时间范围"
          >
          </el-time-picker> -->
          <el-date-picker
            v-model="hourRange"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
          <el-button
            type="primary"
            icon="el-icon-search"
            class="m-ml10"
            @click="handleClickHour"
            >订单时间段分布查询</el-button
          >
        </div>
      </el-col>
    </el-row>
    <el-row class="m-mt20">
      <el-col :span="12">
        <ve-histogram
          :data="amountByShopHour"
          :title="{ text: '订单金额时间段分布统计', left: 'center' }"
          :legend="{ top: 36 }"
          :grid="{ top: 80 }"
          :dataZoom="dataZoomOptions"
        >
          <div
            class="data-empty"
            v-if="!amountByShopHour.rows || !amountByShopHour.rows.length"
          >
            没有数据😂
          </div>
        </ve-histogram>
      </el-col>
      <el-col :span="12">
        <ve-histogram
          :data="countByShopHour"
          :title="{ text: '订单数量时间段分布统计', left: 'center' }"
          :legend="{ top: 36 }"
          :grid="{ top: 80 }"
          :dataZoom="dataZoomOptions"
        >
          <div
            class="data-empty"
            v-if="!countByShopHour.rows || !countByShopHour.rows.length"
          >
            没有数据😂
          </div>
        </ve-histogram>
      </el-col>
    </el-row>
    <el-row class="m-mt20">
      <el-col :span="12">
        <ve-pie
          :data="fromHistogramToPieForHours(amountByShopHour)"
          :settings="orderRatechartSettingsHour"
          :title="{ text: '订单金额时间段占有率', left: 'center' }"
          :legend="{ top: 50 }"
          height="500px"
        >
          <div
            class="data-empty"
            v-if="!amountByShopHour.rows || !amountByShopHour.rows.length"
          >
            没有数据😂
          </div>
        </ve-pie>
      </el-col>
      <el-col :span="12">
        <ve-pie
          :data="fromHistogramToPieForHours(countByShopHour)"
          :settings="orderRatechartSettingsHour"
          :title="{ text: '订单数量时间段占有率', left: 'center' }"
          :legend="{ top: 50 }"
          height="500px"
        >
          <div
            class="data-empty"
            v-if="!countByShopHour.rows || !countByShopHour.rows.length"
          >
            没有数据😂
          </div>
        </ve-pie>
      </el-col>
    </el-row>
    <hr />
    <el-row class="m-mt20">
      <el-col :span="18">
        <div class="block">
          <span class="demonstration">日期范围：</span>
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
          <el-button
            type="primary"
            icon="el-icon-search"
            class="m-ml10"
            @click="handleClickDaily"
            >每日订单查询</el-button
          >
        </div>
      </el-col>
    </el-row>
    <el-row class="m-mt20">
      <el-col :span="12">
        <ve-histogram
          :data="amountByShopDaily"
          :title="{ text: '每日订单金额', left: 'center' }"
          :legend="{ top: 36 }"
          :grid="{ top: 80 }"
          :dataZoom="dataZoomOptions"
        >
          <div
            class="data-empty"
            v-if="!amountByShopDaily.rows || !amountByShopDaily.rows.length"
          >
            没有数据😂
          </div>
        </ve-histogram>
      </el-col>
      <el-col :span="12">
        <ve-histogram
          :data="countByShopDaily"
          :title="{ text: '每日订单数量', left: 'center' }"
          :legend="{ top: 36 }"
          :grid="{ top: 80 }"
          :dataZoom="dataZoomOptions"
        >
          <div
            class="data-empty"
            v-if="!countByShopDaily.rows || !countByShopDaily.rows.length"
          >
            没有数据😂
          </div>
        </ve-histogram>
      </el-col>
    </el-row>
    <el-row class="m-mt20">
      <el-col :span="12">
        <ve-pie
          :data="fromHistogramToPie('门店', '订单金额', amountByShopDaily)"
          :settings="orderRatechartSettings"
          :title="{ text: '订单金额每日占有率', left: 'center' }"
          :legend="{ top: 50 }"
        >
          <div
            class="data-empty"
            v-if="!amountByShopDaily.rows || !amountByShopDaily.rows.length"
          >
            没有数据😂
          </div>
        </ve-pie>
      </el-col>
      <el-col :span="12">
        <ve-pie
          :data="fromHistogramToPie('门店', '订单数量', countByShopDaily)"
          :settings="orderRatechartSettings"
          :title="{ text: '订单数量每日占有率', left: 'center' }"
          :legend="{ top: 50 }"
        >
          <div
            class="data-empty"
            v-if="!countByShopDaily.rows || !countByShopDaily.rows.length"
          >
            没有数据😂
          </div>
        </ve-pie>
      </el-col>
    </el-row>
    <hr />
    <el-row class="m-mt20">
      <el-col :span="18">
        <div class="block">
          <span class="demonstration">月份范围：</span>
          <el-date-picker
            v-model="monthRange"
            type="monthrange"
            range-separator="~"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
          >
          </el-date-picker>
          <el-button
            type="primary"
            icon="el-icon-search"
            class="m-ml10"
            @click="handleClickMonth"
            >月度订单查询</el-button
          >
        </div>
      </el-col>
    </el-row>
    <el-row class="m-mt20">
      <el-col :span="12">
        <ve-histogram
          :data="amountByShopMonth"
          :title="{ text: '每月订单金额', left: 'center' }"
          :legend="{ top: 36 }"
          :grid="{ top: 80 }"
          :dataZoom="dataZoomOptions"
        >
          <div
            class="data-empty"
            v-if="!amountByShopMonth.rows || !amountByShopMonth.rows.length"
          >
            没有数据😂
          </div>
        </ve-histogram>
      </el-col>
      <el-col :span="12">
        <ve-histogram
          :data="countByShopMonth"
          :title="{ text: '每月订单数量', left: 'center' }"
          :legend="{ top: 36 }"
          :grid="{ top: 80 }"
          :dataZoom="dataZoomOptions"
        >
          <div
            class="data-empty"
            v-if="!countByShopMonth.rows || !countByShopMonth.rows.length"
          >
            没有数据😂
          </div>
        </ve-histogram>
      </el-col>
    </el-row>
    <el-row class="m-mt20">
      <el-col :span="12">
        <ve-pie
          :data="fromHistogramToPie('门店', '订单金额', amountByShopMonth)"
          :settings="orderRatechartSettings"
          :title="{ text: '订单金额每月占有率', left: 'center' }"
          :legend="{ top: 50 }"
        >
          <div
            class="data-empty"
            v-if="!amountByShopMonth.rows || !amountByShopMonth.rows.length"
          >
            没有数据😂
          </div>
        </ve-pie>
      </el-col>
      <el-col :span="12">
        <ve-pie
          :data="fromHistogramToPie('门店', '订单数量', countByShopMonth)"
          :settings="orderRatechartSettings"
          :title="{ text: '订单数量每月占有率', left: 'center' }"
          :legend="{ top: 50 }"
        >
          <div
            class="data-empty"
            v-if="!countByShopMonth.rows || !countByShopMonth.rows.length"
          >
            没有数据😂
          </div>
        </ve-pie>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      shopList: [],
      dataZoomOptions: {
        type: "slider"
      },
      selectedShop: [],
      hourRange: [],
      dateRange: [],
      monthRange: [],
      amountByShopDaily: {},
      countByShopDaily: {},
      amountByShopMonth: {},
      countByShopMonth: {},
      amountByShopHour: {},
      countByShopHour: {},
      orderRatechartSettings: {
        radius: 120,
        offsetY: 250
      },
      orderRatechartSettingsHour: {
        radius: 120,
        offsetY: 320
      }
    };
  },
  methods: {
    getOrderReportAmountByShopDaily(selectedShop, dateRange) {
      return new Promise(resolve => {
        this.$axios(this.$urlMapping["查询门店每日订单金额"], {
          data: {
            shopids: selectedShop,
            from: this.$ToDateTimeString(dateRange[0]),
            to: this.$ToDateTimeString(dateRange[1])
          }
        }).then(result => {
          resolve(result);
        });
      });
    },
    getOrderReportCountByShopDaily(selectedShop, dateRange) {
      return new Promise(resolve => {
        this.$axios(this.$urlMapping["查询门店每日订单总量"], {
          data: {
            shopids: selectedShop,
            from: this.$ToDateTimeString(dateRange[0]),
            to: this.$ToDateTimeString(dateRange[1])
          }
        }).then(result => {
          resolve(result);
        });
      });
    },
    getOrderReportAmountByShopHourly(selectedShop, hourRange) {
      return new Promise(resolve => {
        this.$axios(this.$urlMapping["查询门店每小时订单金额"], {
          data: {
            shopids: selectedShop,
            from: this.$ToDateTimeString(hourRange[0]),
            to: this.$ToDateTimeString(hourRange[1])
          }
        }).then(result => {
          resolve(result);
        });
      });
    },
    getOrderReportCountByShopHourly(selectedShop, hourRange) {
      return new Promise(resolve => {
        this.$axios(this.$urlMapping["查询门店每小时订单总量"], {
          data: {
            shopids: selectedShop,
            from: this.$ToDateTimeString(hourRange[0]),
            to: this.$ToDateTimeString(hourRange[1])
          }
        }).then(result => {
          resolve(result);
        });
      });
    },
    getOrderReportAmountByShopMonthly(selectedShop, monthRange) {
      return new Promise(resolve => {
        this.$axios(this.$urlMapping["查询门店每月订单金额"], {
          data: {
            shopids: selectedShop,
            from: this.$ToDateTimeString(monthRange[0]),
            to: this.$ToDateTimeString(monthRange[1])
          }
        }).then(result => {
          resolve(result);
        });
      });
    },
    getOrderReportCountByShopMonthly(selectedShop, monthRange) {
      return new Promise(resolve => {
        this.$axios(this.$urlMapping["查询门店每月订单总量"], {
          data: {
            shopids: selectedShop,
            from: this.$ToDateTimeString(monthRange[0]),
            to: this.$ToDateTimeString(monthRange[1])
          }
        }).then(result => {
          resolve(result);
        });
      });
    },
    handleClickDaily() {
      if (
        Array.isArray(this.dateRange) &&
        this.dateRange.length > 0 &&
        this.selectedShop.length > 0
      ) {
        Promise.all([
          this.getOrderReportAmountByShopDaily(
            this.selectedShop,
            this.dateRange
          ),
          this.getOrderReportCountByShopDaily(this.selectedShop, this.dateRange)
        ])
          .then(values => {
            this.amountByShopDaily = values[0];
            this.countByShopDaily = values[1];
          })
          .catch(reason => {
            console.log(reason);
          });
      } else {
        this.$notify.error({
          title: "消息",
          message: "请选择门店和时间范围后再查询"
        });
      }
    },
    handleClickMonth() {
      if (
        Array.isArray(this.monthRange) &&
        this.monthRange.length > 0 &&
        this.selectedShop.length > 0
      ) {
        Promise.all([
          this.getOrderReportAmountByShopMonthly(
            this.selectedShop,
            this.monthRange
          ),
          this.getOrderReportCountByShopMonthly(
            this.selectedShop,
            this.monthRange
          )
        ])
          .then(values => {
            this.amountByShopMonth = values[0];
            this.countByShopMonth = values[1];
          })
          .catch(reason => {
            console.log(reason);
          });
      } else {
        this.$notify.error({
          title: "消息",
          message: "请选择门店和月份范围后再查询"
        });
      }
    },
    handleClickHour() {
      if (
        Array.isArray(this.hourRange) &&
        this.hourRange.length > 0 &&
        this.selectedShop.length > 0
      ) {
        Promise.all([
          this.getOrderReportAmountByShopHourly(
            this.selectedShop,
            this.hourRange
          ),
          this.getOrderReportCountByShopHourly(
            this.selectedShop,
            this.hourRange
          )
        ])
          .then(values => {
            this.amountByShopHour = values[0];
            this.countByShopHour = values[1];
          })
          .catch(reason => {
            console.log(reason);
          });
      } else {
        this.$notify.error({
          title: "消息",
          message: "请选择门店和时间范围后再查询"
        });
      }
    }
  },
  mounted() {
    this.$axios(this.$urlMapping["查询门店"], {
      data: {}
    }).then(result => {
      this.shopList = result.data.map(item => item.shopInfoEntity);
      let count = this.shopList.length > 3 ? 3 : this.shopList.length;
      for (let index = 0; index < count; index++) {
        this.selectedShop.push(this.shopList[index].shopid);
      }

      if (this.$route.query.shopid) {
        this.selectedShop = [this.$route.query.shopid];
      }

      this.hourRange = this.dateRange = this.monthRange = [
        moment().subtract(1, "days"),
        moment()
      ];

      this.$nextTick(() => this.handleClickHour());
      this.$nextTick(() => this.handleClickDaily());
      this.$nextTick(() => this.handleClickMonth());
    });
  }
};
</script>

<style lang="less" scoped></style>
